import { ContentLimiter } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { Gewerbeberechtigung } from 'components/profiles';
import React from 'react';
import { PersonPlusDto } from 'types/personen';
import { useTranslation } from 'utils/hooks';

interface GewerbeberechtigungenProps 
{
  person: PersonPlusDto;
}

const Gewerbeberechtigungen: React.FC<GewerbeberechtigungenProps> = (props) =>
{
  const { person } = props;
  const { t } = useTranslation('profiles');
  
  return (
    <>

      {/* Gewerbeberechtigungen */}
      {person.gisa && person.gisa.length > 0 && (
        <ContentRow id="gewerbeberechtigungen" title={t('profiles:gewerbe.label')}>

          <ul className="no-list-style">
            <ContentLimiter>
              {person.gisa.map((gewerbe) => (
                <Gewerbeberechtigung key={gewerbe.gisaNr} gewerbe={gewerbe} />
              ))}
            </ContentLimiter>
          </ul>

        </ContentRow>
      )}

      {/* Gewerbeberechtlicher Geschäftsführer */}
      {person.geschäftsführer && person.geschäftsführer.length > 0 && (
        <ContentRow id="gewerberechtlicher-geschäftsführer" title={t('profiles:gewerbe.gewerberechtlicherGeschäftsführer')}>
          
          <ul className="no-list-style">
            <ContentLimiter>
              {person.geschäftsführer.map((gewerbe) => (
                <Gewerbeberechtigung key={gewerbe.gisaNr} gewerbe={gewerbe} />
              ))}
            </ContentLimiter>
          </ul>

        </ContentRow>
      )}
    </>
  );
};

export default Gewerbeberechtigungen;
